<template>
    <div
      v-if="alertVisible"
      :class="['alert', 'alert-' + alertType]"
      style="position: fixed; z-index: 2222; width: 100%; max-width: 350px; top: 100px; left: 10px;"
    >
      <button type="button" class="close" @click="hideAlert">×</button>
      {{ alertMessage }}
    </div>
  </template>
  
  <script setup lang="ts">
  import { useGlobalAlert } from '~/composables/useGlobalAlert'
  
  const { alertMessage, alertType, alertVisible, hideAlert } = useGlobalAlert()
  </script>
  
  <style scoped>
 
  </style>
  